<script lang="ts">
	import { PUBLIC_COMPANY_NAME, PUBLIC_SITE_NAME } from '$env/static/public';
	import Container from '@components/global/Container.svelte';
	import { links } from './data';
	import { getCopyrightYear } from '@lib/utils';
	import logoImg from '@lib/images/logo/brand.webp?enhanced';
</script>

<footer class="relative bg-base-100 pt-8 text-center pre-lg:text-left">
	<slot name="content">
		<Container>
			<div class="grid gap-5 pre-lg:grid-cols-[0.5fr_1fr]">
				<div>
					<a href="/" aria-label="Logo">
						<enhanced:img
							loading="lazy"
							class="mx-auto aspect-[128/35] w-full max-w-56 pre-lg:mx-0"
							src={logoImg}
							alt={PUBLIC_SITE_NAME}
						/>
					</a>
					<p class="mt-4 text-balance text-sm text-gray-500">
						{PUBLIC_COMPANY_NAME} merupakan perusahaan penerbit buku di Indonesia yang berfokus menerbitkan
						buku pendidikan, buku ajar, referensi, hingga monograf dalam bentuk buku digital.
					</p>
				</div>
				<div class="grid gap-5 pre-md:grid-cols-3">
					{#each links as linkData}
						<div>
							<p class="mb-4 text-xl font-semibold">{linkData.name}</p>
							<ul class="grid gap-3">
								{#each linkData.links as link}
									{@const isExternalLink = link.url.startsWith('http') || !!link.is_external}
									<li>
										<a
											href={link.url}
											target={isExternalLink ? '_blank' : null}
											rel={isExternalLink ? 'noopener noreferrer' : null}
											class="flex items-center justify-center gap-2 pre-lg:justify-start"
										>
											{#if link.icon}
												<img
													loading="lazy"
													class="aspect-square size-5"
													src={link.icon}
													alt="{link.label}'s link"
												/>
											{/if}
											{link.label}
										</a>
									</li>
								{/each}
							</ul>
						</div>
					{/each}
				</div>
			</div>
		</Container>
		<div class="mt-8 bg-base-200 py-5">
			<Container>
				<p class="text-center text-sm text-gray-500">
					Copyright &copy; {getCopyrightYear()}
					{PUBLIC_SITE_NAME}. All rights reserved.
				</p>
			</Container>
		</div>
	</slot>
</footer>
